var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 3,
    viewBox: "0 0 17 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.45833C0.5 1.7125 0.600967 1.95625 0.78069 2.13598C0.960412 2.3157 1.20417 2.41667 1.45833 2.41667C1.7125 2.41667 1.95625 2.3157 2.13598 2.13598C2.3157 1.95625 2.41667 1.7125 2.41667 1.45833C2.41667 1.20417 2.3157 0.960412 2.13598 0.78069C1.95625 0.600967 1.7125 0.5 1.45833 0.5C1.20417 0.5 0.960412 0.600967 0.78069 0.78069C0.600967 0.960412 0.5 1.20417 0.5 1.45833ZM7.20833 1.45833C7.20833 1.7125 7.3093 1.95625 7.48902 2.13598C7.66875 2.3157 7.9125 2.41667 8.16667 2.41667C8.42083 2.41667 8.66459 2.3157 8.84431 2.13598C9.02403 1.95625 9.125 1.7125 9.125 1.45833C9.125 1.20417 9.02403 0.960412 8.84431 0.78069C8.66459 0.600967 8.42083 0.5 8.16667 0.5C7.9125 0.5 7.66875 0.600967 7.48902 0.78069C7.3093 0.960412 7.20833 1.20417 7.20833 1.45833ZM13.9167 1.45833C13.9167 1.7125 14.0176 1.95625 14.1974 2.13598C14.3771 2.3157 14.6208 2.41667 14.875 2.41667C15.1292 2.41667 15.3729 2.3157 15.5526 2.13598C15.7324 1.95625 15.8333 1.7125 15.8333 1.45833C15.8333 1.20417 15.7324 0.960412 15.5526 0.78069C15.3729 0.600967 15.1292 0.5 14.875 0.5C14.6208 0.5 14.3771 0.600967 14.1974 0.78069C14.0176 0.960412 13.9167 1.20417 13.9167 1.45833Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotIconBlack);
export default __webpack_public_path__ + "static/media/threeDotIconBlack.e8a9482c529396249fded57a230c23f5.svg";
export { ForwardRef as ReactComponent };